import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectAcuerdosMrbState = (state: AppState) => state.acuerdosMRB;

export const selectAllAcuerdos = createSelector(
  selectAcuerdosMrbState,
  (state) => state
);

export const selectAcuerdos = createSelector(
  selectAcuerdosMrbState,
  (state) => state.acuerdos
);
export const selectAcuedoActual = createSelector(
  selectAcuerdosMrbState,
  (state) => state.acuerdoActual
);
export const selectAcuerdosHistorico = createSelector(
  selectAcuerdosMrbState,
  (state) => state.historico
);
export const selectTipoAcuerdo = createSelector(
  selectAcuerdosMrbState,
  (state) => state.tipoAcuerdo
);

export const selectNuevoAcuerdo = createSelector(
  selectAcuerdosMrbState,
  (state) => state.nuevoAcuerdo
);

export const selectAcuerdoByTipo = (tipoAcuerdo: number) =>
  createSelector(selectAllAcuerdos, (all) => {
    switch (tipoAcuerdo) {
      case 1:
        return all.acuerdoActual;
      case 2:
        return all.acuerdos;
      case 3:
        return all.historico;
      default:
        return [];
    }
  });

export const selectAcuerdoById = (acuerdoId: string) =>
  createSelector(selectAcuerdos, (acuerdos) =>
    acuerdos.find((acuerdo) => acuerdo.idFE === acuerdoId)
  );

export const selectAcuerdoActualById = (acuerdoId: string) =>
  createSelector(selectAcuedoActual, (acuerdos) =>
    acuerdos.find((acuerdo) => acuerdo.idFE === acuerdoId)
  );
export const selectAcuerdoHistoricoById = (acuerdoId: string) =>
  createSelector(selectAcuerdosHistorico, (acuerdos) =>
    acuerdos.find((acuerdo) => acuerdo.idFE === acuerdoId)
  );
